var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dropdown',{ref:"dropdown",attrs:{"menu-right":_vm.right}},[_c('a',{staticClass:"dropdown-toggle font150 pointy"},[_c('i',{staticClass:"glyphicon glyphicon-cog"})]),_c('template',{slot:"dropdown"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }